import { cva, type VariantProps } from 'class-variance-authority';

import { twMerge } from 'tailwind-merge';

const spinner = cva(['relative', 'inline-block'], {
  variants: {
    size: {
      sm: ['w-4', 'h-4'],
      md: ['w-8', 'h-8'],
      lg: ['w-12', 'h-12'],
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

const logo = 'absolute inset-0 w-full h-full transition-opacity duration-300';

export interface FloxSpinnerProps extends VariantProps<typeof spinner> {
  isAnimating?: boolean;
  className?: string;
}

export function FloxSpinner({
  size,
  isAnimating = true,
  className,
}: FloxSpinnerProps) {
  const activityAnnouncement = isAnimating
    ? { role: 'status', 'aria-label': 'Loading' }
    : { 'aria-hidden': true };

  return (
    <span
      className={twMerge(spinner({ size }), className)}
      {...activityAnnouncement}
    >
      <img
        src='/images/flox-spinner-static.svg'
        alt=''
        className={twMerge(
          logo,
          isAnimating ? 'opacity-0' : 'opacity-100',
          'motion-reduce:opacity-100'
        )}
      />
      <img
        src='/images/flox-spinner.svg'
        alt=''
        className={twMerge(
          logo,
          isAnimating ? 'opacity-100' : 'opacity-0',
          'motion-reduce:opacity-0'
        )}
      />
    </span>
  );
}
